export { default } from './Minus'
